const AppConstants = {
  ACCOUNT_ID_COOKIE_NAME: 'ACCOUNT_ID',
  JWT_COOKIE_NAME: 'JWT',
  JWT_HEADER_PREFIX: 'Bearer',
  ACCOUNT_ID_QUERY_PARAM: 'accountId',
  PARAM_TARGET_ACCOUNT_ID: 'targetAccountId',
  ACCOUNT_ID_QUERY_PARAM_FOR_DCP_ONLY: 'accountID', // Little Caveat for DCP
  ENVRIONMENT_QUERY_PARAM: 'env',
  DO_REFRESH_QUERY_PARAM: 'doRefresh',
  TYPE_QUERY_PARAM: 'type',
  USER_PARAM_VALUE: 'user',
  AUTHENTICATION_PARAM_VALUE: 'authentication',
  ACCOUNT_PARAM_VALUE: 'account',
  BOOMI_URL: 'https://www.boomi.com/',
  BOOMI_POLICY_URL: 'https://www.boomi.com/privacy/',
  BOOMI_STATUS_URL: 'https://status.boomi.com/',
  FLOW_APP_URL: 'https://flow.boomi.com/',
  DCP_APP_URL: 'https://router.boomi-dcp.com/requests',
  DOCUMENTATION_APP_URL: 'https://help.boomi.com/',
  SUPPORT_APP_URL: 'https://community.boomi.com/s/support', // DEFAULT ONE BUT ACTUAL WILL BE GENERATED USING SSOHANDLER
  COMMUNITY_APP_URL: 'https://community.boomi.com/s/training',
  TRAINING_APP_URL: 'https://train.boomi.com/',
  BOOMILABS_BUNDLES_MARKETING_URL: 'https://boomi.com/boomi-labs/#bundles',
  BOOMILABS_SPACES_MARKETING_URL: 'https://boomi.com/boomi-labs/#spaces',
  // DEFAULT_ACCOUNT_NAME_KEY: 'header_menu_accountName_default',
  SWITCH_RECENT_ACCOUNT_PREFIX_ID: 'ID:',
  MASTHEAD_RESOURCE_CENTER_SELECTOR: 'qm-c-masthead__help-icon',
  REQUEST_HEADER_CONTENT_TYPE_DEFAULT: {
    'Content-Type': 'application/json',
  },
  X_BOOMI_BUNDLE_SOURCE: 'boomi-ai',

  // CUSTOM BRANDING COLOR CSS PROPERTIES
  VARIABLE_COLOR_BACKGROUND_MASTHEAD: '--color-background-masthead',
  VARIABLE_COLOR_BACKGROUND_MASTHEAD_HOVER: '--color-background-masthead-hover',
  VARIABLE_COLOR_FOREGROUND_MASTHEAD: '--color-foreground-masthead',
  VARIABLE_COLOR_BACKGROUND_SERVICENAV_HOVER: '--color-background-servicenav-hover',
  VARIABLE_COLOR_BACKGROUND_BUTTON_HOVER: '--color-background-button-hover',
  VARIABLE_COLOR_BACKGROUND_MENU_HOVER: '--color-background-menu-hover',

  // Notification Messages Utils
  HELP_ID_PREFIX: '${helpId=',
  HELP_ID_SUFFIX: '}',
  URL_PREFIX: 'url:',
  PATH: 'path:',
  PRODUCTION_HOST: 'platform.boomi.com',
  PRODUCTION_GB_HOST: 'platform.gb.boomi.com',
  PRODUCTION_HOSTS: ['platform.boomi.com', 'platform.gb.boomi.com'],
  QA_HOST: 'qa.boomi.com',
  PRODCLONE_HOST: 'prodclone.boomi.com',
  PC4_PREPROD_HOST: 'pc4.preprod.boomi.com',
  PATH_HELP_PRODUCTION: 'https://help.boomi.com%p',
  PATH_HELP_PRODUCTION_GB: 'https://help.boomi.com%p',
  PATH_HELP_QA: 'https://staging.dev.help.boomi.com%p',
  PATH_PLACEHOLDER: '%p',
  HELP_ID_DELIMITER: ':',
  GUID_PREFIX: 'GUID-',
  GUID_POSTFIX: '/csh?context=',
  EMPTY_STRING: '',
  HTML_LINE_BREAK: '<br/>',

  // Discover constants
  DISCOVER_SOLUTIONS_MAX_COUNT: 43,
  DISCOVER_SOLUTIONS_PAGE_SIZE: 5,
  DISCOVER_MAX_CONNECTOR_ICONS_IN_CARD: 3,
  DISCOVER_BROWSE_SOLUTIONS_URL: 'https://marketplace.boomi.com/browse-solutions',
  DISCOVER_PROD_URL: 'https://marketplace.boomi.com/',
  DISCOVER_PROD_GRAPHQL_ENDPOINT: 'https://live-b-discover.pantheonsite.io/graphql',
  DISCOVER_QA_GRAPHQL_ENDPOINT: 'https://qa-internal.marketplace.cj-pipeline.boomi.com/graphql',
  DISCOVER_DEV_GRAPHQL_ENDPOINT: `${window.location.origin}/graphql`,
  ACC_FORM_LOGGED_IN: 4741,
  ACC_FORM_LOGGED_OUT: 4987,
  ACC_FORM_PHONE_REGEX: /^[0-9\-().\s+]*$/,

  // Marketplace agents graphql endpoint
  MARKETPLACE_AGENTS_GRAPHQL_ENDPOINT: `${window.location.origin}/graphql`,

  // Marketplace agents constants
  AGENT_SOLUTIONS_MAX_COUNT: 43,
  AGENT_SOLUTIONS_PAGE_SIZE: 5,

  // Usage Summary
  USAGE_URL_DEV: 'https://api.usage.datalake-sandbox.boomi.com',

  // Key Code Constants for Key Event
  KEY_CODE: {
    ENTER: 'Enter',
  },

  HTTP_STATUS_CODE: {
    STATUS_401_UNAUTHORIZED: 401,
    STATUS_403_FORBIDDEN: 403,
    STATUS_419_SESSION_EXPIRED: 419,
  },

  LEFT_NAV_SUBMENUS: [
    {
      id: 'HOME',
      title: 'Home',
      link: '/BoomiAI.html#/home',
      submenus: [],
      variant: 'ANCHOR_MENU_ITEM',
    },
    {
      id: 'AGENT_DESIGNER',
      title: 'Agent Designer',
      link: '/BoomiAI.html#/agent-designer',
      submenus: [],
      variant: 'ANCHOR_MENU_ITEM',
    },
    {
      id: 'AGENTS',
      title: 'Agents',
      link: '/BoomiAI.html#/agents',
      submenus: [],
      variant: 'ANCHOR_MENU_ITEM',
    },
    {
      id: 'TOOLS',
      title: 'Tools',
      link: '/BoomiAI.html#/tools',
      submenus: [],
      variant: 'ANCHOR_MENU_ITEM',
    },
    {
      id: 'SOURCES',
      title: 'Sources',
      link: '/BoomiAI.html#/sources',
      submenus: [],
      variant: 'ANCHOR_MENU_ITEM',
    },
    {
      id: 'MODELS',
      title: 'Models',
      link: '/BoomiAI.html#/models',
      submenus: [],
      variant: 'ANCHOR_MENU_ITEM',
    },
    {
      id: 'ENVIRONMENTS',
      title: 'Environments',
      link: '/BoomiAI.html#/environments',
      submenus: [],
      variant: 'ANCHOR_MENU_ITEM',
    },
    {
      id: 'PACKAGES_AND_DEPLOYMENTS',
      title: 'Packages and Deployments',
      link: '/BoomiAI.html#/packages-deployments',
      submenus: [],
      variant: 'ANCHOR_MENU_ITEM',
    },
    {
      id: 'CHAT',
      title: 'Chat',
      link: '/BoomiAI.html#/chat',
      submenus: [],
      variant: 'ANCHOR_MENU_ITEM',
    },
  ],
};

export function isProductionHost(): boolean {
  const currentHost = window.location.hostname;
  return AppConstants.PRODUCTION_HOSTS.includes(currentHost);
}

export default AppConstants;
